import Viewport from './Viewport'
import NativeWindowBinding from './NativeWindowBinding'

const nativeBinding = new NativeWindowBinding(window)
const viewport = new Viewport(window, nativeBinding)
export default viewport